import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import serviceReducer from './slices/serviceSlice';
import newsReducer from './slices/newsSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  service: serviceReducer,
  news: newsReducer,
});

export default rootReducer; 